import { render, staticRenderFns } from "./ResponseFile.vue?vue&type=template&id=fa182270&scoped=true"
import script from "./ResponseFile.vue?vue&type=script&lang=js"
export * from "./ResponseFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa182270",
  null
  
)

export default component.exports